import { useEffect, useRef } from "react";

// Registers WebMCP tools against the current browser API. Tool callbacks are
// read through a ref so React state changes do not unregister an in-flight
// tool merely because its closure changed.
export default function useWebMcpTools(tools) {
  const toolsRef = useRef(tools);
  toolsRef.current = tools;

  const definitionsKey = JSON.stringify(
    (tools || []).map(({ execute, ...definition }) => definition)
  );

  useEffect(() => {
    const modelContext = document?.modelContext;
    if (!modelContext?.registerTool || !toolsRef.current?.length) return undefined;

    const controller = new AbortController();
    const definitions = toolsRef.current.map(({ execute, ...definition }) => ({
      ...definition,
      execute: (...args) => {
        const currentTool = toolsRef.current.find(
          (candidate) => candidate.name === definition.name
        );
        if (!currentTool?.execute) {
          throw new Error(`WebMCP tool is no longer available: ${definition.name}`);
        }
        return currentTool.execute(...args);
      },
    }));

    Promise.allSettled(
      definitions.map((tool) =>
        modelContext.registerTool(tool, { signal: controller.signal })
      )
    ).then((results) => {
      results.forEach((result, index) => {
        if (result.status === "rejected" && !controller.signal.aborted) {
          console.warn(
            `Could not register WebMCP tool ${definitions[index].name}`,
            result.reason
          );
        }
      });
    });

    return () => controller.abort();
  }, [definitionsKey]);
}
